import { ReactNode } from 'react';

import classNames from 'classnames';

import { Text } from '@spotify-internal/encore-web';

import styles from './ChatInformationBox.module.css';

export type ChatInformationBoxProps = {
  title: ReactNode;
  icon?: ReactNode;
  children?: ReactNode;
  className?: string;
};

export const ChatInformationBox = ({
  title,
  icon,
  children,
  className,
}: ChatInformationBoxProps) => {
  return (
    <div className={classNames(styles.root, className)}>
      {icon ? (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <div className={styles.content}>
        {typeof title === 'string' ? (
          <Text variant="bodySmall">{title}</Text>
        ) : (
          title
        )}
        {children}
      </div>
    </div>
  );
};
